/** draft — still collecting. published — a city guide may cite it. */
export enum GuideStatusEnum {
    DRAFT = 'draft',
    PUBLISHED = 'published',
}

export const GUIDE_STATUS_ORDER: GuideStatusEnum[] = [
    GuideStatusEnum.DRAFT,
    GuideStatusEnum.PUBLISHED,
];
